import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import find from 'lodash/find';
import { FormattedMessage } from 'react-intl';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import rightArrowSVG from '@plone/volto/icons/right-key.svg';

/**
 * Registered via config.settings.appExtras (matches every route) so it
 * renders on every content page. It only *shows* something once it does:
 * this is a <Plug> that portals into the "More" menu's
 * "toolbar-more-menu-list" slot, same mechanism Volto's own Sharing/History
 * links use, just triggered from outside core instead of hardcoded in
 * More.jsx. Gated on the same "edit" action Volto itself uses to decide
 * whether editing is allowed at all - whether the content type actually has
 * the password-protection behavior enabled is checked once the panel opens,
 * not here, to avoid an extra fetch just for a menu item.
 */
const MoreMenuLink = ({ pathname }) => {
  const actions = useSelector((state) => state.actions?.actions?.object);
  const editAction = find(actions, { id: 'edit' });
  const path = getBaseUrl(pathname);

  if (!editAction) {
    return null;
  }

  return (
    <Plug pluggable="toolbar-more-menu-list" id="password-protection">
      <li>
        <Link to={`${path}/password-protection`}>
          <FormattedMessage
            id="Password Protection"
            defaultMessage="Password Protection"
          />
          <Icon name={rightArrowSVG} size="24px" />
        </Link>
      </li>
    </Plug>
  );
};

export default MoreMenuLink;
